export default __webpack_public_path__ + "static/media/Icon-Check_Gold.5b34f52d.svg";